export const FIREBASE_COLLECTIONS = {
  users: 'users',
  questionAttributes: 'questionAttributes',
  paperAttributes: 'paperAttributes',
  questions: 'questions',
  schools: 'schools',
  papers: 'papers',
};
